/**
 * Keys, which belong to Coverage Package.
 */
export const coveragePackageKeys = [
    "coverageA",
    "coverageB",
    "coverageC",
    "coverageDLossOfUse",
    "coverageEPremisesLiability",
    "coverageEPersonalLiability",
    "coverageFMedicalPaymentToOthers",
    "deductibles",
    "animalLiability",
    "damageToPropertyOfOthers",
    "fungiWetOrDryRotOrBacteriaProperty",
    "inflationGuard",
    "roofPaymentSchedule",
    "waterDamage",
];
export const policyLevelExtraCoverageKeys = [
    "scheduledPersonalProperty",
    "identityFraud",
];
/**
 * Keys, which belong to Extra Coverage.
 * Those are in order as rendered on the Extra Coverage page.
 */
export const extraCoverageKeys = [
    "mineSubsidence",
    "mineSubsidenceScheduled",
    ...policyLevelExtraCoverageKeys,
    "golfCarts",
    "enhancedCoverage",
    "equipmentBreakdown",
    "tripCollision",
    "earthquake",
    "vacationRental",
    "waterBackupAndSumpOverflow",
    "incidentalFarming",
    "landlordPersonalInjury",
    "lossAssessment",
    "debrisRemoval",
    "sinkhole",
    "residenceBurglary",
    "roofPaymentSchedule",
    "buildersRisk",
    "secondaryResidenceLiability",
    "vandalismOrMaliciousMischief",
    "windstormOrHailExclusion",
    "fortifiedRoofUpgrade",
];
/**
 * Names of the deductibles.
 */
export const namesOfDeductibles = [
    "allOtherPerilsDeductible",
    "windHailDeductible",
    "waterDamageDeductible",
];
